import { Language } from 'src/shared/constants/languages';
export const LanguageHelper = {
    normalizeLocale(locale) {
        const amountOfCharactersToSplitLocale = 2;
        const currentLocale = locale.replace('_', '-');
        const language = currentLocale.slice(0, amountOfCharactersToSplitLocale).toLowerCase();
        const area = currentLocale.slice(amountOfCharactersToSplitLocale).toUpperCase();
        return `${language}${area}`;
    },
    async setLanguage(locale, i18n) {
        try {
            const resource = await import(`src/core/languages/${locale}.json`);
            i18n.addResourceBundle(locale, 'translation', resource);
            i18n.changeLanguage(locale);
        }
        catch {
            i18n.changeLanguage(Language.En);
        }
    }
};
export default LanguageHelper;
